<template>
  <div class="layout-screen view-course">

    <TheHeader />
    <router-view />
  </div>
</template>

<script>
import CourseList from "./list.vue";

export default {
  name: "ViewCourseList",
  components: {
    CourseList,
  },
};
</script>

<style lang="postcss">
    .view-course {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
</style>
